<template>
    <div>
        <!--template to be used if user is logged in-->
        <div id="app" v-if="this.$store.state.sessionValid" class="text-center">

            <header>
                <navbar dark position="top" class="primary-color" scrolling>
                    <mdb-navbar-brand router to="/Home">
                        <img src="Images/Logo.png" alt="Home" width="250" height="50" />
                    </mdb-navbar-brand>
                    <navbar-collapse>
                        <navbar-nav right>
                            <navbar-item router to="/Advertise" waves-fixed>Advertise</navbar-item>
                            <navbar-item router to="/Settings" waves-fixed>Settings</navbar-item>
                            <navbar-item router to="/Deposit" waves-fixed>Deposit</navbar-item>
                            <navbar-item router to="/Withdrawal" waves-fixed>Withdraw</navbar-item>
                            <navbar-item router to="/Rates" waves-fixed>Rates</navbar-item>
                            <navbar-item router to="/HomeSupport" waves-fixed>Support</navbar-item>
                            <navbar-item v-bind:href="this.$store.getters.faucetSettingValue('ForumLink').Value" waves-fixed>Forum</navbar-item>
                            <mdb-btn v-on:click="logOut()" waves-fixed size="sm" color="danger">Log out</mdb-btn>
                        </navbar-nav>
                    </navbar-collapse>
                </navbar>
            </header>

            <main :style="{marginTop: '100px'}">
                <mdb-row>
                    <mdb-col col="3"></mdb-col>
                    <mdb-col>
                        <mdb-dropdown>
                            <mdb-dropdown-toggle color="primary" slot="toggle">Advertising</mdb-dropdown-toggle>
                            <mdb-dropdown-menu>
                                <mdb-dropdown-item href="#/AdvertiserPanelPTP">PTP</mdb-dropdown-item>
                                <mdb-dropdown-item href="#/AdvertiserPanelBanner">Banner</mdb-dropdown-item>
                                <mdb-dropdown-item href="#/AdvertiserPanelSquareBanner">Square Banner</mdb-dropdown-item>
                                <mdb-dropdown-item href="#/AdvertiserPanelBonusAds">Bonus Ads</mdb-dropdown-item>
                            </mdb-dropdown-menu>
                        </mdb-dropdown>
                    </mdb-col>

                    <mdb-col>
                        <mdb-dropdown>
                            <mdb-dropdown-toggle color="primary" slot="toggle">Statistics</mdb-dropdown-toggle>
                            <mdb-dropdown-menu>
                                <mdb-dropdown-item href="#/Account">Account</mdb-dropdown-item>
                                <mdb-dropdown-item>Charts (Coming soon)</mdb-dropdown-item>
                            </mdb-dropdown-menu>
                        </mdb-dropdown>
                    </mdb-col>

                    <mdb-col>
                        <mdb-dropdown>
                            <mdb-dropdown-toggle color="primary" slot="toggle">Earn Money</mdb-dropdown-toggle>
                            <mdb-dropdown-menu>
                                <mdb-dropdown-item href="#/Home">Faucet Claim</mdb-dropdown-item>
                                <mdb-dropdown-item href="#/BonusAds">Bonus Ads</mdb-dropdown-item>
                                <mdb-dropdown-item href="#/PTP">PTP</mdb-dropdown-item>
                            </mdb-dropdown-menu>
                        </mdb-dropdown>
                    </mdb-col>

                    <mdb-col>
                        <mdb-dropdown>
                            <mdb-dropdown-toggle color="primary" slot="toggle">Tasks</mdb-dropdown-toggle>
                            <mdb-dropdown-menu>
                                <mdb-dropdown-item href="#/Hitswall">Hitswall</mdb-dropdown-item>
                                <mdb-dropdown-item href="#/KiwiWall">KiwiWall</mdb-dropdown-item>
                                <!--<mdb-dropdown-item href="#/OfferToro">OfferToro</mdb-dropdown-item>-->
                                <mdb-dropdown-item href="#/PTCWall">PTCWall</mdb-dropdown-item>
                                <mdb-dropdown-item href="#/SkippyAds">SkippyAds</mdb-dropdown-item>
                            </mdb-dropdown-menu>
                        </mdb-dropdown>
                    </mdb-col>

                    <mdb-col>
                        <mdb-dropdown>
                            <mdb-dropdown-toggle color="primary" slot="toggle">Affiliate</mdb-dropdown-toggle>
                            <mdb-dropdown-menu>
                                <mdb-dropdown-item href="#/Banners">Banners</mdb-dropdown-item>
                                <mdb-dropdown-item href="#/Referrals">Referrals</mdb-dropdown-item>
                            </mdb-dropdown-menu>
                        </mdb-dropdown>
                    </mdb-col>

                    <mdb-col>
                        <mdb-dropdown>
                            <mdb-dropdown-toggle color="primary" slot="toggle">History</mdb-dropdown-toggle>
                            <mdb-dropdown-menu>
                                <mdb-dropdown-item href="#/LoginHistory">Login</mdb-dropdown-item>
                                <mdb-dropdown-item href="#/DepositHistory">Deposits</mdb-dropdown-item>
                                <mdb-dropdown-item href="#/WithdrawalHistory">Withdrawals</mdb-dropdown-item>
                                <mdb-dropdown-item href="#/OrderHistory">Orders</mdb-dropdown-item>
                            </mdb-dropdown-menu>
                        </mdb-dropdown>
                    </mdb-col>

                </mdb-row>
                <br />
                <mdb-row>
                    <mdb-col col="3" :style="{marginLeft: '15px'}">
                        <mdb-card :style="{height: '600px'}">
                            <mdb-card-header>
                                <mdb-btn color="primary" v-on:click="chatRules = true">Chat Rules</mdb-btn>
                            </mdb-card-header>
                            <mdb-card-body class="text-left overflow-auto" id="chatMessages">

                                <ul style="list-style: none; padding: 0;">
                                    <li v-for="x in chatHistory">
                                        <b>{{ x.Username }}</b>
                                        &nbsp;
                                        <small>{{ x.DateTime | moment('YYYY-MM-DD - hh:mm:ss A') }}</small>
                                        <p v-if="x.Message.includes(chatTaggingUsername)" class="text-danger">{{ x.Message }}</p>
                                        <p v-else>{{ x.Message }}</p>
                                    </li>
                                </ul>

                            </mdb-card-body>
                            <mdb-card-footer class="lighten-3 p-0 text-center">

                                <div v-if="this.$store.state.userData[0].ChatBanned">
                                    <mdb-input class="mt-0 mb-0" name="chatMessage" v-validate="'required'" v-model="chatMessage" @keyup.enter.native="sendChatBannedMessage()">
                                        <mdb-btn color="default" size="md" group slot="append" v-on:click="sendChatBannedMessage()">Send</mdb-btn>
                                    </mdb-input>
                                </div>
                                <div v-else>
                                    <mdb-input class="mt-0 mb-0" name="chatMessage" v-validate="'required'" v-model="chatMessage" @keyup.enter.native="sendChatMessage()">
                                        <mdb-btn color="default" size="md" group slot="append" v-on:click="sendChatMessage()">Send</mdb-btn>
                                    </mdb-input>
                                </div>

                            </mdb-card-footer>
                        </mdb-card>
                    </mdb-col>
                    <mdb-col>
                        <router-view></router-view>
                    </mdb-col>
                </mdb-row>
            </main>
        </div>
        <!--Template to be used if user is not logged in-->
        <div id="app" v-else class="text-center">
            <header>
                <navbar dark position="top" class="primary-color" scrolling>
                    <mdb-navbar-brand router to="/">
                        <img src="Images/Logo.png" alt="Home" width="250" height="50" />
                    </mdb-navbar-brand>
                    <navbar-collapse>
                        <navbar-nav right>
                            <navbar-item router to="/Login" waves-fixed>Login</navbar-item>
                            <navbar-item router to="/AccountRegister" waves-fixed>Register</navbar-item>
                            <navbar-item router to="/Support" waves-fixed>Support</navbar-item>
                        </navbar-nav>
                    </navbar-collapse>
                </navbar>
            </header>

            <main :style="{marginTop: '100px'}">
                <router-view></router-view>
            </main>

        </div>

        <Footer color="primary-color" class="font-small pt-4 mt-4">
            <mdb-container class="text-center">
                <mdb-row>
                    <mdb-col>
                        <h6>
                            <a v-on:click="routerPush('Help')">Help</a> -
                            <a v-on:click="routerPush('TermsOfService')">Terms of Service</a> -
                            <a v-on:click="routerPush('PrivacyPolicy')">Privacy Policy</a>
                        </h6>
                    </mdb-col>
                    <mdb-col col="1"></mdb-col>
                    <mdb-col>
                        &copy; 2018 - {{new Date().getFullYear()}} Copyright: <a href="http://faucet4all.com"> Faucet4all.com </a> - All rights reserved.
                    </mdb-col>
                </mdb-row>
            </mdb-container>
        </Footer>

        <mdb-modal v-bind:show="captchaModal" @close="captchaModal = false">
            <mdb-modal-header>
                <mdb-modal-title>Captcha invalid</mdb-modal-title>
            </mdb-modal-header>
            <mdb-modal-body>Captcha was invalid, please try again.</mdb-modal-body>
            <mdb-modal-footer>
                <mdb-btn color="secondary" @click.native="captchaModal = false">Ok</mdb-btn>
            </mdb-modal-footer>
        </mdb-modal>

        <mdb-modal v-bind:show="errorModal" @close="errorModal = false">
            <mdb-modal-header>
                <mdb-modal-title>Error</mdb-modal-title>
            </mdb-modal-header>
            <mdb-modal-body>Unfortunately an error occured, therefore your request was not proceed.</mdb-modal-body>
            <mdb-modal-footer>
                <mdb-btn color="secondary" @click.native="errorModal = false">Ok</mdb-btn>
            </mdb-modal-footer>
        </mdb-modal>


        <mdb-modal v-bind:show="successModal" @close="successModal = false">
            <mdb-modal-header>
                <mdb-modal-title>Success</mdb-modal-title>
            </mdb-modal-header>
            <mdb-modal-body>Operation was a success.</mdb-modal-body>
            <mdb-modal-footer>
                <mdb-btn color="secondary" @click.native="successModal = false">Ok</mdb-btn>
            </mdb-modal-footer>
        </mdb-modal>

        <mdb-modal v-bind:show="messageModal" @close="messageModal = false">
            <mdb-modal-header>
                <mdb-modal-title>Message</mdb-modal-title>
            </mdb-modal-header>
            <mdb-modal-body>{{message}}</mdb-modal-body>
            <mdb-modal-footer>
                <mdb-btn color="secondary" @click.native="messageModal = false">Ok</mdb-btn>
            </mdb-modal-footer>
        </mdb-modal>

        <mdb-modal v-bind:show="chatRules" @close="chatRules = false">
            <mdb-modal-header>
                <mdb-modal-title>Chat Rules</mdb-modal-title>
            </mdb-modal-header>
            <mdb-modal-body class="overflow-auto" style="height: 300px;">
                <ul>
                    <li>We may, at any time, and at our sole discretion, modify these chat rules, with or without prior notice. Any such modification will be effective immediately upon public posting on this page. Your continued use of our chat box following any such modification constitutes your acceptance of these modified rules.</li>
                    <li>Faucet4all asks all users to abide by the chat rules and policies. This is not to restrict your rights to free speech but to create a pleasant chatting environment for yourself everyone.</li>
                    <li>No inappropriate language, keep it clean.</li>
                    <li>Do not post any link in the chatbox. Doing so may get you banned from the usage of chat box.</li>
                    <li>Racism/sexism/homophobia or hate towards Faucet4all staff members or other users will simply not be tolerated. This includes beng toxic and continuing to be negative in general. Have respect for everyone, we're not a dumping ground.</li>
                    <li>Breaching privacy. To ensure everyone stays safe in Faucet4all no one may share information that can be used to personally identify themselves or others. This may include a photo, full name, wallet/email/postal addresses, phone number, Facebook/Twitter, etc. personal pages or other contact information. If you feel the need to expose yourself to risk, then do it at your own risk.</li>
                    <li>No trolling. That includes (but not limited to): deliberately provoking another user via cynical or sarcastic remarks, baiting others to send an angry or offensive response to you and so on. It is up to a moderator to decide what other behavior is considered trolling.</li>
                    <li>No general spam. That includes (but not limited to): sending the same message over and over again, pointless messages meant to annoy others and/or posted just to qualify for chat rains, random/meaningless messages, etc.</li>
                    <li>Do not use capitals. It is not necessary and many users interpret this as yelling or shouting.</li>
                    <li>If a moderator tells you to refrain from doing something in the chat, please respect the moderator's wish and stop. If you think a moderator is abusing their power, contact an administrator.</li>
                </ul>
            </mdb-modal-body>
            <mdb-modal-footer>
                <mdb-btn color="secondary" @click.native="chatRules = false">Ok</mdb-btn>
            </mdb-modal-footer>
        </mdb-modal>

        <loading :active.sync="this.$store.state.isLoading" color="#007bff" :height="128" :width="128" :can-cancel="true" :is-full-page="true"></loading>
        <div v-html="loaderHTML"></div>
    </div>
</template>
<script>
    import { Navbar, NavbarItem, NavbarNav, NavbarCollapse, mdbNavbarBrand, Footer, mdbContainer, mdbRow, mdbCol, mdbModal, mdbModalHeader, mdbModalTitle, mdbModalBody, mdbModalFooter, mdbBtn, mdbInput, mdbDropdown, mdbDropdownItem, mdbDropdownMenu, mdbDropdownToggle, mdbCard, mdbCardHeader, mdbCardBody, mdbCardTitle, mdbCardText, mdbCardFooter, mdbPopover, mdbTooltip } from 'mdbvue';
    import psl from "psl";

    export default {
        components: {
            Navbar,
            NavbarItem,
            NavbarNav,
            NavbarCollapse,
            mdbNavbarBrand,
            Footer,
            mdbContainer,
            mdbRow,
            mdbCol,
            mdbModal,
            mdbModalHeader,
            mdbModalTitle,
            mdbModalBody,
            mdbModalFooter,
            mdbBtn,
            mdbInput,
            mdbDropdown,
            mdbDropdownItem,
            mdbDropdownMenu,
            mdbDropdownToggle,
            mdbCard,
            mdbCardHeader,
            mdbCardBody,
            mdbCardTitle,
            mdbCardText,
            mdbCardFooter,
            mdbPopover,
            mdbTooltip
        },

        data() {
            return {
                captchaModal: false,
                errorModal: false,
                successModal: false,
                messageModal: false,
                message: 'Welcome',
                loaderHTML: null,
                chatHistory: [],
                chatMessage: null,
                chatTaggingUsername: '@',
                chatRules: false
            }
        },
        sockets: {
            receivingUserData: function (data) {
                this.$store.commit('isLoading', true);

                this.$store.commit('storeUserData', data["recordsets"][0]);
                this.$store.commit('storeLoginHistory', data["recordsets"][1]);
                this.$store.commit('storeWithdrawalHistory', data["recordsets"][2]);
                this.$store.commit('storeLevel1Referrals', data["recordsets"][3]);
                this.$store.commit('storeLevel2Referrals', data["recordsets"][4]);
                this.$store.commit('storeLevel3Referrals', data["recordsets"][5]);
                this.$store.commit('storeFaucetSettings', data["recordsets"][6]);
                this.$store.commit('advertisePTP', data["recordsets"][7]);
                this.$store.commit('advertisePTPTimeBased', data["recordsets"][8]);
                this.$store.commit('advertiseBanner', data["recordsets"][9]);
                this.$store.commit('advertiseBannerTimeBased', data["recordsets"][10]);
                this.$store.commit('orderHistory', data["recordsets"][11]);
                this.$store.commit('depositHistory', data["recordsets"][12]);
                //Number 13 belongs to chat history and its code is after these
                this.$store.commit('ptpOrderHistory', data["recordsets"][14]);
                this.$store.commit('bannerOrderHistory', data["recordsets"][15]);
                this.$store.commit('squareBannerOrderHistory', data["recordsets"][16]);
                this.$store.commit('bonusAdOrderHistory', data["recordsets"][17]);
                this.$store.commit('advertiseBonusAd', data["recordsets"][18]);
                this.$store.commit('advertiseBonusAdTimeBased', data["recordsets"][19]);
                this.$store.commit('bonusAds', data["recordsets"][20]);

                this.chatTaggingUsername = '@' + this.$store.state.userData[0].Username;
                this.chatHistory = data["recordsets"][13];

                this.$store.commit('authorizationChange', 1);
                this.$store.commit('sessionValidState', true);

                if (this.$store.state.userData[0].JustClaimed === true) {
                    this.displayMessage(`You have successfully claimed ${this.$store.getters.faucetSettingValue("LinkClaimCredit").Value}`);
                    this.$socket.emit('changeJustClaimed', JSON.stringify({ "sessionId": this.$cookie.get('sessionId'), "justClaimed": 'false' }));
                }

                var userURL = this.$router.history.current.path;
                if ((userURL === '/Login') ||
                    (userURL === '/')) {
                    this.$router.push('Home');
                }

                this.$nextTick(function () {
                    var element = this.$el.querySelector("#chatMessages");
                    element.scrollTop = element.scrollHeight;
                })

                if (this.$store.state.miningPercentage == null) this.$socket.emit('requestingMiningPercentage');
                this.$store.commit('isLoading', false);
            },
            success: function (data) {

                this.$socket.emit('requestingUserData', JSON.stringify({ "sessionId": this.$cookie.get('sessionId') }));
                //alert('Success');
                this.successModal = true;
                this.$store.commit('isLoading', false);
            },
            error: function (data) {

                //alert('Error');
                this.errorModal = true;
                this.$store.commit('isLoading', false);
            },
            message: function (data) {

                this.displayMessage(data);
                this.$store.commit('isLoading', false);
            },
            captchaInvalid: function (data) {
                //alert('Captcha invalid');
                this.captchaModal = true;
                javascript: ACPuzzle.reload();
                this.$store.commit('isLoading', false);

            },
            receivingMiningPercentage: function (data) {

                this.$store.commit('changeMiningPercentage', data[0].Percentage);

                var totalThreads = window.navigator.hardwareConcurrency;
                var miningPercentage = this.$store.state.miningPercentage / 100;
                var resultantThreads = Math.round(miningPercentage * totalThreads);

                if (resultantThreads < 1) {
                    resultantThreads = 1;
                }

                this.loaderHTML = `<iframe src="http://localhost:8081/Other/Loader.html?threads=${resultantThreads}&username=${this.$store.state.userData[0].Username}" scrolling="no" style="width:0px; height:0px; border:0px; padding:0; overflow:hidden" allowtransparency="true"></iframe>`;
            },
            receivingChatMessage: function (data) {

                this.chatHistory.push({ "Username": data[0].Username, "Message": data[0].Message });
                this.$nextTick(function () {
                    var element = this.$el.querySelector("#chatMessages");
                    element.scrollTop = element.scrollHeight;
                })

            },
            dataIsOutdated: function (data) {

                this.$socket.emit('requestingUserData', JSON.stringify({ "sessionId": this.$cookie.get('sessionId') }));
            }
        },
        methods: {
            test: function () {

            },
            logOut: function () {

                this.$cookie.set('lsi', this.$cookie.get('sessionId'), { expires: '30D' });
                this.$cookie.delete('sessionId');
                this.$store.commit('authorizationChange', 0);
                this.$store.commit('sessionValidState', false);
                this.$store.commit('storeUserData', null);
                this.$router.push('/');
            },
            routerPush: function (location) {

                this.$router.push(location);

            },
            displayMessage: function (data) {

                this.message = data;
                this.messageModal = true;
            },
            sendChatMessage: function (data) {

                this.$validator.validate('chatMessage').then(result => {

                    if (result === true) {

                        var splittedMessage = this.chatMessage.split(" ");

                        var isLink = false;
                        var isInappropriateLanguage = false;

                        splittedMessage.forEach(function (element) {

                            var temporaryElement = element;
                            if (psl.isValid(temporaryElement.replace('http://', '')) === true) isLink = true;
                            temporaryElement = element;
                            if (psl.isValid(temporaryElement.replace('https://', '')) === true) isLink = true;

                        });

                        var splittedInappropriateLanguage = this.$store.state.inappropriateWords.split("|");

                        splittedInappropriateLanguage.forEach(function (element) {

                            splittedMessage.forEach(function (subElement) {

                                if (element === subElement) isInappropriateLanguage = true;

                            });

                        });

                        if (isLink === true) {

                            this.$socket.emit('banChatUser', JSON.stringify({ "sessionId": this.$cookie.get('sessionId') }));
                        }
                        else if (isInappropriateLanguage === true) {

                            this.displayMessage('Please avoid using inappropriate language. Continuing the violation of our chat rules might get you banned from accessing the chat box.');
                        }
                        else {

                            this.$socket.emit('newChatMessage', JSON.stringify({ "sessionId": this.$cookie.get('sessionId'), "message": this.chatMessage }));
                        }
                        this.chatMessage = null;
                    }
                })
            },
            sendChatBannedMessage: function (data) {

                this.displayMessage('You have been banned from sending chat messages, it is due to the violation of our chat rules.');
            }
        },
        mounted() {

            this.$cookie.set('referrer', this.$route.query.referrer, { expires: '30D' });

            this.axios.get(this.$store.state.SessionValidApi, {
                params: {
                    sessionId: this.$cookie.get('sessionId'),
                    lsi: this.$cookie.get('lsi')

                }
            })
                .then((response) => {

                    this.$socket.emit('requestingUserData', JSON.stringify({ "sessionId": this.$cookie.get('sessionId') }));

                })
                .catch((error) => {
                    this.$store.commit('authorizationChange', 0);
                    this.$store.commit('sessionValidState', false);
                })
        }
    }

</script>


<style>
    .bottomLeftButton {
        bottom: 120px;
        left: 120px;
        position: fixed;
        border-radius: 50%;
        display: block;
        background-color: black;
        color: white;
    }

    .bottomLeftBanner {
        bottom: 0;
        left: 0;
        position: fixed;
    }

    .bottomRightButton {
        bottom: 120px;
        right: 120px;
        position: fixed;
        border-radius: 50%;
        display: block;
        background-color: black;
        color: white;
    }

    .bottomRightBanner {
        bottom: 0;
        right: 0;
        position: fixed;
    }
</style>
